import React from 'react';
import { IconProps } from '../../icons/types';

const IdCard: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2801 10.74C13.4064 10.74 15.1301 9.01634 15.1301 6.89004C15.1301 4.76374 13.4064 3.04004 11.2801 3.04004C9.15376 3.04004 7.43005 4.76374 7.43005 6.89004C7.43005 9.01634 9.15376 10.74 11.2801 10.74Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11.28 20.96H3.25005C3.13959 20.96 3.0498 20.8699 3.05244 20.7594C3.15871 16.3024 6.79711 12.73 11.28 12.73C12.09 12.73 12.88 12.85 13.62 13.07"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.46 15.65H20.88"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15.46 20.97H20.88"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15.46 18.31H20.88"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IdCard;
